import { isObject, isString } from 'lodash';

import { env } from '~/shared/utils/env';

const navatticDemoUrls = {
  BoQ: 'https://cosuno.navattic.com/bk380knj',
  PCT: 'https://cosuno.navattic.com/904s0bue',
} as const;
export type NavatticDemoType = keyof typeof navatticDemoUrls;
export const getNavatticDemoUrl = (type: NavatticDemoType) => navatticDemoUrls[type];

interface NavatticCompleteFlowEvent {
  path: string;
  type: 'COMPLETE_FLOW';
}

export const isNavatticCompleteFlowEvent = (event: unknown): event is NavatticCompleteFlowEvent =>
  isObject(event) &&
  'path' in event &&
  isString(event.path) &&
  'type' in event &&
  event.type === 'COMPLETE_FLOW';

export const shouldCloseNavatticLightboxOnEvent = (
  event: unknown,
): event is NavatticCompleteFlowEvent =>
  isNavatticCompleteFlowEvent(event) &&
  Object.values(navatticDemoUrls).some((demoUrl) => demoUrl.endsWith(event.path));

export const getNavatticLightboxElementFromEvent = (event: NavatticCompleteFlowEvent) => {
  const lightboxId = event.path.split('/').pop();
  return document.getElementById(
    `navattic-lightbox-${lightboxId}`,
  ) as NavatticLightboxElement | null;
};

export const openNavatticModal = ({
  demoUrl,
  title,
  onOpen = () => {},
}: {
  demoUrl: string;
  title: string;
  onOpen?: () => void;
}) => {
  if (env.REACT_APP_CYPRESS === 'true') {
    return onOpen();
  }

  if (window.NavatticEmbed) {
    window.NavatticEmbed.initPopup(demoUrl, { title });
    window.NavatticEmbed.openPopup(demoUrl);

    // This hack is meant to make Navattic's background overlay significantly
    // darker. The purpose is that the user is less distracted by our actual product
    // in the background.
    // Note: this may stop working if Navattic changes anything in the DOM structure.
    const navatticLightbox = window.NavatticEmbed.getLightboxByUrl(demoUrl);
    const backgroundElement = navatticLightbox?.shadowRoot?.children[0]?.children[0]?.children[0];
    if (backgroundElement) {
      backgroundElement.setAttribute('style', '--tw-bg-opacity: 0.95');
    }

    onOpen();
  }
};
